import { styled } from '@mui/material';

export const Wrap = styled('div')(({ theme }) => ({
	background: theme.palette.success.main,
	color: theme.palette.success.contrastText,

	gap: '8px',
	borderRadius: '8px',
	padding: '4px 8px',

	'& .MuiTypography-root': {
		verticalAlign: 'middle',
	},

	'& svg': {
		width: '24px',
		height: '24px',
		flexShrink: 0,
		verticalAlign: 'middle',
	},
}));

export const CommentContent = styled('div')({
	display: 'inline',
	'& p': {
		display: 'inline',
		margin: 0,
	},
});
